import { render, staticRenderFns } from "./brandWall.vue?vue&type=template&id=68375528&scoped=true"
import script from "./brandWall.vue?vue&type=script&lang=js"
export * from "./brandWall.vue?vue&type=script&lang=js"
import style0 from "./brandWall.vue?vue&type=style&index=0&id=68375528&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68375528",
  null
  
)

export default component.exports